import type { VideoAspectRatio, VideoDuration } from '@mntn-dev/domain-types'
import { Stack } from '../../stack/stack.tsx'
import { Text } from '../../text/text.tsx'
import { BladeMediaDuration } from './blade-media-duration.tsx'

type MediaInfo = {
  description?: string
  duration?: VideoDuration
  timeInterval: string
  aspectRatio?: VideoAspectRatio
}

type BladeMediaInfoProps = {
  media: MediaInfo
  t: (key: 'or') => string
}

const BladeMediaInfo = ({
  media: { duration, description, timeInterval, aspectRatio },
  t,
}: BladeMediaInfoProps) => {
  return (
    <Stack direction="col" gap="1">
      <Text textColor="primary" fontSize="base" fontWeight="bold">
        {description}
      </Text>
      <Stack direction="row" gap="2">
        {duration !== undefined && (
          <Stack alignItems="baseline">
            <BladeMediaDuration
              duration={duration}
              timeInterval={timeInterval}
              t={t}
            />
          </Stack>
        )}
        {aspectRatio && (
          <Text fontWeight="semibold" textColor="info" fontSize="xs">
            {aspectRatio}
          </Text>
        )}
      </Stack>
    </Stack>
  )
}

export { BladeMediaInfo, type BladeMediaInfoProps, type MediaInfo }
